<div class="item-container">
  <div (click)="goToFrameReturn()">
    <div class="product-item__image">
      <img [src]="image" [alt]="name" class="img-responsive" onError="this.src='/assets/images/frame-default-lg.png'" />
    </div>

    <strong class="product-item__title">{{ title }}</strong>
    <div class="product-item__desc1">{{ desc1 }}</div>
    <div class="product-item__desc2">{{ desc2 }}</div>
    <div class="product-item__desc2">{{ clusterName }}</div>
    <div class="product-item__size">{{ size }}</div>
  </div>
  <div class="product-item__button">
    <button class="btn btn-outline" type="button" (click)="goToFrameReturn()">
      Return This Frame
    </button>
  </div>
</div>
